import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  templates: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row-reverse',

    '& h2': {
      fontSize: 30,
      fontWeight: 400,
      color: '#616161',
      margin: 0,
    },

    '& p': {
      color: '#616161',
    },

    '& h2 span': {
      color: COLOR_PURPLE,
      fontWeight: 700,
    },
  },
  linkReference: {
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: 700,
    width: 'fit-content',
    fontFamily: 'Lato',
    fontSize: 18,
  },
  paragraph: {
    lineHeight: 1.15,
    fontFamily: 'Lato',
    fontSize: 18,
    letterSpacing: 0,
  },
}));
